/* eslint-disable max-lines */
import React from "react";
import { formatMoney } from "../../utils/money";
import Select from "react-select";
import _ from "lodash";
import { translate } from "./translate";
import { withRouter } from "react-router-dom";
import { Container, FlexBox } from "../../Components";
import AppContext from "../../AppContext";
import {
  getOrders,
  getCustomerForId,
  getCurrentOrderId,
  getTotalPrice,
} from "../../selectors";
import { formatDate, formatTime } from "../../utils/date";
import { isOrderEditable } from "../../utils/order";
import { CreateNewOrderButton } from "./CreateNewOrderButton";
import { OrderStatusAndResync } from "./OrderStatusAndResync";
import { UpdateOrderButton } from "./UpdateOrderButton";
import { SelectOrderButton } from "./SelectOrderButton";
import { Actions } from "./Actions";
import { SyncOrdersSalesforce } from "./SyncOrdersSalesforce";
import EmptyStateForOrdersList from "./EmptyStateForOrdersList";

import "./OrdersList.scss";
import LinkToSalesforce from "../../Components/LinkToSalesforce";

class OrderList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: props.orders,
      filter: {
        customer: null,
        season: null,
        status: null,
      },
    };
  }

  onFilterChange = (filter) => {
    this.setState({ filter: filter });
  };

  onAction = () => {
    setTimeout(() => {
      this.setState({ orders: prepareOrders(this.props.context) });
    }, 1000);
  };

  render() {
    const orders = this.state.orders;
    const filter = this.state.filter;
    const filtered = filterOrders(orders, filter);

    return (
      <div>
        <OrderListHeader orders={filtered} />
        <OrderFilterOptions
          orders={orders}
          filter={filter}
          onFilterChange={this.onFilterChange}
          onSeasonChange={this.onSeasonChange}
        />

        <OrderEntriesWithRouter orders={filtered} onAction={this.onAction} />
      </div>
    );
  }
}

class OrderFilterOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.filter,
    };

    this.filter = props.filter;
  }

  changeFilter = (e, name) => {
    let v = null;
    if (e !== null) {
      v = e.value;
    }

    this.filter[name] = v;
    this.props.onFilterChange(this.filter);
  };

  onSeasonChange = (e) => {
    this.changeFilter(e, "season");
  };

  onCustomerChange = (e) => {
    this.changeFilter(e, "customer");
  };

  onStatusChange = (e) => {
    this.changeFilter(e, "status");
  };

  render() {
    const orders = this.props.orders;
    const filter = this.props.filter;
    const customers = extractCustomers(orders);
    const statuses = extractStatuses(orders);
    const seasons = extractSeasons(orders);

    const currentSeason = filter.season;
    const currentCustomer = filter.customer;
    const currentStatus = filter.status;

    return (
      <div className="filter-header">
        <div className="filter-column">
          <b>{translate("filter.status")}:</b>{" "}
          <StatusFilter
            status={currentStatus}
            statuses={statuses}
            onChange={this.onStatusChange}
          />
          <br />
        </div>
        <div className="filter-column">
          <b>{translate("filter.season")}:</b>{" "}
          <SeasonFilter
            season={currentSeason}
            seasons={seasons}
            onChange={this.onSeasonChange}
          />
          <br />
        </div>
        <div className="filter-column">
          <b>{translate("filter.customer")}:</b>{" "}
          <CustomerFilter
            customer={currentCustomer}
            customers={customers}
            onChange={this.onCustomerChange}
          />
        </div>
      </div>
    );
  }
}

function extractCustomers(orders) {
  let customers = {};
  orders.forEach((o) => {
    customers[o.customerId] = { name: o.customerName, no: o.customerNo };
  });

  let customersList = [];
  Object.keys(customers).forEach((k) => {
    let c = customers[k];
    customersList.push({
      id: k,
      name: c.name,
      no: c.no,
    });
  });

  return customersList;
}

function extractStatuses(orders) {
  return extractUniqValues(orders, "status");
}

function extractSeasons(orders) {
  return extractUniqValues(orders, "season");
}

function extractUniqValues(orders, field) {
  let m = {};
  orders.forEach((o) => {
    m[o[field]] = true;
  });

  return Object.keys(m);
}

function orderSum(orders) {
  let vals = {};
  orders.forEach((r) => {
    const x = r;
    // const x = JSON.parse(JSON.stringify(r));
    const v = x.total || {};

    if (_.isNil(v.currency)) {
      v.currency = "EUR";
    }

    if (vals[v.currency] === undefined) {
      vals[v.currency] = 0;
    }

    let total = 0;
    if (v.totalWithDiscount && v.totalWithDiscount > 0) {
      total = v.totalWithDiscount;
    }

    vals[v.currency] += total;
  });

  let currencies = Object.keys(vals);

  return currencies
    .map((c) => {
      if (vals[c] > 0) {
        return formatMoney(vals[c], c);
      }
      return null;
    })
    .filter((e) => e);
}

const OrderSum = (props) => {
  const orders = props.orders;
  const sums = orderSum(orders);

  if (sums.length === 0) {
    return null;
  }

  return (
    <div className="order-header-sum">
      <div className="order-header-sum-col order-sum">Summe</div>
      <div className="order-header-sum-col">
        {sums.map((s) => (
          <div key={s} className="order-header-sum-row">
            {s}
          </div>
        ))}
      </div>
    </div>
  );
};

const StatusFilter = (props) => {
  const options = props.statuses.map((status) => {
    return { value: status, label: `${translate(status)}` };
  });

  return (
    <Select
      isSearchable={false}
      isClearable={true}
      onChange={props.onChange}
      options={options}
    />
  );
};

const SeasonFilter = (props) => {
  const options = props.seasons.map((season) => {
    return { value: season, label: `${season}` };
  });

  return (
    <Select
      isSearchable={false}
      isClearable={true}
      onChange={props.onChange}
      options={options}
    />
  );
};

const OrderListHeader = (props) => {
  const orders = props.orders;
  return (
    <>
      <div className="order-info">
        <FlexBox
          style={{ width: "100%" }}
          marginTop="sm"
          flexDirection="column"
        >
          <FlexBox flex={1} justifyContent="space-between">
            <CreateNewOrderButton />
            <SyncOrdersSalesforce />
          </FlexBox>
        </FlexBox>
      </div>

      <div className="order-header">
        <div>Orders ({orders.length})</div>
        <div className="right">
          <OrderSum orders={orders} />
        </div>
      </div>
    </>
  );
};

const CustomerFilter = (props) => {
  const options = props.customers.map((c) => {
    return { value: c.id, label: `${c.name} (${c.no})` };
  });

  return (
    <Select
      isSearchable={true}
      isClearable={true}
      defaultValue={props.customer}
      onChange={props.onChange}
      options={options}
    />
  );
};

function filterOrders(orders, filter) {
  let filteredOrders = [];

  orders.forEach((o) => {
    if (filter.season && filter.season !== o.season) {
      return;
    }

    if (filter.status && filter.status !== o.status) {
      return;
    }

    if (filter.customer && filter.customer !== o.customerId) {
      return;
    }

    filteredOrders.push(o);
  });

  return filteredOrders;
}

function prepareOrders(context) {
  const rawOrders = getOrders(context);
  const currentOrderId = getCurrentOrderId(context);

  const formatOrderType = (doc) => {
    if (!doc.orderType) {
      return "PREORDER";
    }
    return doc.orderType.value;
  };
  const parsedOrders = rawOrders
    .map((o) => {
      const orderData = getTotalPrice(context, o);
      const doc = o.doc;
      const customerId = o.doc.customerId;
      const customer = getCustomerForId(context, customerId);

      if (!customer) {
        return null;
      }

      return {
        id: o.id,
        doc_id: o.doc.id,
        customerId: customer.Id,
        customerName: customer.Name,
        customerNo: customer.CustomerNo__c,
        season: doc.season,
        status: !!doc.salesforce_id ? doc.status : "unsynced",
        address: doc.deliveryAddress,
        amount: orderData.totalWithDiscount,
        total: orderData,
        date: doc.orderDate,
        discount: doc.discount,
        orderNumber: doc.orderNumber,
        currentOrder: o.id === currentOrderId,
        setCurrentOrder: context.actions.setCurrentOrder,
        orderType: formatOrderType(o.doc),
        deliveryAddress: o.doc.deliveryAddress,
        products: o.doc.products,
        context: context,
      };
    })
    .filter((e) => e);
  return parsedOrders;
}

export const OrdersList = () => {
  return (
    <div className="margin-10p">
      <Container>
        <AppContext.Consumer>
          {(context) => {
            const orders = prepareOrders(context);
            return <OrderList orders={orders} context={context} />;
          }}
        </AppContext.Consumer>
      </Container>
    </div>
  );
};

const orderCurrency = (o) => {
  if (!o.total.currency) {
    return `EUR`;
  }

  return o.total.currency;
};

const orderAmount = (o) => {
  const discount = o.discount > 0 ? `(-${o.discount}%)` : "";
  const val = formatMoney(o.total.totalWithDiscount, o.total.currency);
  if (!o.total.currency) {
    return `0,00`;
  }
  return `${val} ${discount}`;
};
const orderDate = (d) => {
  if (!d) {
    return "no date";
  }

  return (
    <>
      <span>{formatDate(d.toString())}</span>
      <br />
      <span>{formatTime(d.toString())}</span>
    </>
  );
};

const orderStatus = (s) => {
  return <span>{translate(s)}</span>;
};

const orderAddress = (a) => {
  if (!a) {
    return <div>no address</div>;
  }

  return (
    <div>
      <div>{a.name}</div>
      <div>{a.street}</div>
      <div>
        {a.postalCode} {a.city}
      </div>
    </div>
  );
};

const classForOrder = (order) => {
  if (new Date() - new Date(order.date) < 1 * 60 * 1000) {
    return "new-order";
  }

  return "";
};

const OrderEntries = (props) => {
  const orders = _.reverse(_.sortBy(props.orders, (o) => o.date));
  if (orders.length === 0) {
    return <EmptyStateForOrdersList />;
  }

  const { history } = props;

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>{translate("tableHeaders.client")}</th>
            <th>{translate("tableHeaders.orderDate")}</th>
            <th>
              {translate("tableHeaders.id")} &{" "}
              {translate("tableHeaders.season")}
            </th>
            <th>{translate("tableHeaders.address")}</th>
            <th></th>
            <th>{translate("tableHeaders.sum")}</th>
            <th>{translate("tableHeaders.status")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => {
            return (
              <tr key={o.id} className={classForOrder(o)}>
                <td>
                  <LinkToSalesforce obj={{ Id: o.customerId }} />
                  {!o.currentOrder && <span>{o.customerName}</span>}
                  {o.currentOrder && <b>{o.customerName}</b>}
                </td>
                <td>{orderDate(o.date)}</td>
                <td>
                  {o.doc_id}
                  <br />
                  {o.season}
                  <br />
                  {o.orderNumber}
                </td>
                <td>{orderAddress(o.address)}</td>
                <td>
                  <div>
                    <SelectOrderButton
                      setCurrentOrder={o.setCurrentOrder}
                      id={o.id}
                      push={history.push}
                    />
                  </div>
                  <div>
                    {isOrderEditable(o) && (
                      <UpdateOrderButton id={o.id} push={history.push} />
                    )}
                  </div>
                </td>
                <td>{orderAmount(o)}</td>
                <td>{orderStatus(o.status)}</td>
                <td>
                  <div>
                    <OrderStatusAndResync
                      context={o.context}
                      order={o}
                      history={history}
                    />
                  </div>
                  <div>
                    <Actions
                      actions={o.context.actions}
                      onAction={props.onAction}
                      status={o.status}
                      order={o}
                      id={o.id}
                      currency={orderCurrency(o)}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

const OrderEntriesWithRouter = withRouter(OrderEntries);

export default OrdersList;
